import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectSection', 'textBoxSection', 'selectValidation', 'textBoxValidation']
  static values = {
    selectFormat: { type: String, default: 'select' },
    textBoxFormat: { type: String, default: 'text_box' }
  }

  declare readonly hasSelectSectionTarget: boolean
  declare readonly hasTextBoxSectionTarget: boolean
  declare readonly hasSelectValidationTarget: boolean
  declare readonly hasTextBoxValidationTarget: boolean
  declare readonly selectFormatValue: string
  declare readonly textBoxFormatValue: string
  declare readonly selectSectionTarget: HTMLElement
  declare readonly textBoxSectionTarget: HTMLElement
  declare readonly selectValidationTarget: HTMLInputElement
  declare readonly textBoxValidationTarget: HTMLInputElement

  connect (): void {
    this.syncSections()
  }

  formatChanged (): void {
    this.syncSections()
  }

  private syncSections (): void {
    const selectedFormat = this.selectedFormat()
    const selectActive = selectedFormat === this.selectFormatValue
    const textBoxActive = selectedFormat === this.textBoxFormatValue

    if (this.hasSelectSectionTarget) {
      this.toggleSection(this.selectSectionTarget, selectActive)
    }

    if (this.hasTextBoxSectionTarget) {
      this.toggleSection(this.textBoxSectionTarget, textBoxActive)
    }

    if (this.hasSelectValidationTarget) {
      this.selectValidationTarget.disabled = !selectActive
    }

    if (this.hasTextBoxValidationTarget) {
      this.textBoxValidationTarget.disabled = !textBoxActive
    }
  }

  private toggleSection (section: HTMLElement, active: boolean): void {
    section.classList.toggle('hidden', !active)
    section.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement>(
      'input, select, textarea, button'
    ).forEach((element) => {
      if (element.dataset.controlResponseOptionsValidation !== undefined) return
      if (element.dataset.keepDisabled !== undefined) return
      element.disabled = !active
    })
  }

  private selectedFormat (): string {
    const checked = this.element.querySelector<HTMLInputElement>(
      'input[name="control_response_configuration[settings_response_format]"]:checked'
    )

    return checked?.value ?? this.selectFormatValue
  }
}
